"use client";

import Image from "next/image";
import { StepsDisplay, landverpachtungSteps } from "@/components/landing/StepsDisplay";
import { ButtonLink } from "@/components/ui";

export function LandverpachtungSection() {
  return (
    <section id="landverpachtung" className="section-lg px-4 bg-zinc-50">
      <div className="container-wide">
        {/* Section Header */}
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-primary mb-3">Landverpachtung</h2>
          <p className="text-zinc-600 max-w-2xl mx-auto">
            Sie tragen sich mit dem Gedanken, über die Verpachtung Ihres Landes Einnahmen zu
            generieren?
          </p>
        </div>

        {/* Steps */}
        <div className="mb-12">
          <StepsDisplay steps={landverpachtungSteps} />
        </div>

        {/* Row 1: Text Left, Image Right - Ertrag steigern */}
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 mb-12">
          <div className="flex-1">
            <h3 className="text-xl md:text-2xl font-bold text-primary mb-4">
              So steigern Sie den Ertrag Ihrer Flächen
            </h3>
            <p className="text-zinc-600 mb-2">
              Realisieren Sie auf Ihren Flächen lukrative Pachteinnahmen durch Windenergie-,
              Photovoltaik- oder BESS-Anlagen und generieren Sie hierüber zusätzliche Einnahmen.
            </p>
            <p className="text-zinc-700 font-medium mb-6">
              Wir überprüfen Ihre Flächen gerne unverbindlich und kostenfrei auf das individuelle
              Potenzial.
            </p>
            <div className="flex flex-wrap gap-3">
              <ButtonLink href={"/land-verpachten"} variant="secondary">
                Mehr erfahren
              </ButtonLink>
            </div>
          </div>
          <div className="flex-1 relative h-64 md:h-80 w-full rounded-lg overflow-hidden">
            <Image
              src="/content/heroes/land-verpachten.jpg"
              alt="Land verpachten"
              fill
              className="object-cover"
            />
          </div>
        </div>

        {/* Row 2: Image Left, Text Right - Nutzungsrechte */}
        <div className="flex flex-col md:flex-row-reverse items-center gap-8 md:gap-12">
          <div className="flex-1">
            <h3 className="text-xl md:text-2xl font-bold text-primary mb-4">
              Vielfältige Nutzungsrechte
            </h3>
            <p className="text-zinc-600 mb-2">
              Im Rahmen der Landverpachtung erfolgt die Überlassung von land- oder
              forstwirtschaftlichen Flächen zum Gebrauch. Die jeweils vereinbarten Nutzungszwecke
              können heutzutage vielfältig sein: Sie reichen von der klassischen Landwirtschaft bis
              hin zu Projekten der Erneuerbaren Energien.
            </p>
            <p className="text-zinc-600 mb-6">
              Insbesondere letztgenannte Erneuerbare Energien mit der Nutzung von Windenergie, der
              Stromerzeugung durch Photovoltaik oder der Speicherung des Stroms in sogenannten BESS
              (Battery Energy Storage System) stellen für Flächeninhaber zusätzliche Einnahmen dar,
              die die Sicherung der Betriebe für die nächsten Jahrzehnte gewährleisten können.
              Hierbei ist die klassische Landverpachtung zur Fruchtziehung größtenteils dennoch
              möglich.
            </p>
            <ButtonLink href={"/land-verpachten"} variant="outline">
              Mehr erfahren
            </ButtonLink>
          </div>
          <div className="flex-1 relative h-64 md:h-80 w-full rounded-lg overflow-hidden">
            <Image
              src="/content/heroes/nutzungsrechte.jpg"
              alt="Vielfältige Nutzungsrechte"
              fill
              className="object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
